const SlackUserActionTypes = {
    GET_USER_SLACK: "GET_USER_SLACK",
    GET_USER_SLACK_LAST_TIME: "GET_USER_SLACK_LAST_TIME",
    CHANGE_TEAM: "CHANGE_TEAM",
    CHANGE_ACCOUNT: "CHANGE_ACCOUNT",
    CHANGE_STATUS_USER: "CHANGE_STATUS_USER",
  };
  
  export default SlackUserActionTypes;
  